import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppleProfile, FacebookProfile, GoogleProfile, LoginRequest, MiniOrangeLoginRequest } from '../../../../../models';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../shared';

@Injectable({providedIn: 'root'})
export class EcomLoginService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_ECOM_URL_PREFIX  + 'identity/login';
    this.endpoint_path = Core2Config.TENANT_ECOM_URL_PREFIX  + 'identity/login';
    this.httpClient = http;
  }

  ecomLogin(requestData: LoginRequest, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }

  ecomLoginByWebsiteCode(requestData: LoginRequest, visa: ApiVisa, websiteCode: any): Observable<BasicApiResponseModel<any>> {
      let url  = visa.api_domain_url + this.endpoint_path + '?websiteCode=' + websiteCode;
      return this.httpClient.post<BasicApiResponseModel<any>>(url, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }

  ecomLoginWithOtpByWebsiteCode(requestData: LoginRequest, visa: ApiVisa, websiteCode: any): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path + '/with-otp/public-ep?websiteCode=' + websiteCode;
    return this.httpClient.post<BasicApiResponseModel<any>>(url, requestData, { ...this.getHttpHeader(visa), withCredentials: true });
  }

  ecomGoogleLogin(requestData: GoogleProfile, visa: ApiVisa, websiteCode: any) {
    this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login/google?websiteCode=' + websiteCode;
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }

  ecomFacebookLogin(requestData: FacebookProfile, visa: ApiVisa, websiteCode: any) {
    this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login/facebook?websiteCode=' + websiteCode;
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }

  ecomAppleLogin(requestData: AppleProfile, visa: ApiVisa, websiteCode: string): Observable<BasicApiResponseModel<any>> {
    this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + `identity/login/apple?websiteCode=${ websiteCode }`;
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }
  
  ecomMiniOrangeLogin(requestData: MiniOrangeLoginRequest, visa: ApiVisa, websiteCode: any) {
    this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login/miniOrange/public-ep?websiteCode=' + websiteCode;
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, requestData, {...this.getHttpHeader(visa), withCredentials: true});
  }
}
